type AllConditionsData = {
  name: string
  href: string
}[]

const conditionsData: AllConditionsData = [
  {
    name: 'New',
    href: '/all-auctions?condition=%5B"New"%5D',
  },
  {
    name: 'Like New',
    href: '/all-auctions?condition=%5B"Like%20New"%5D',
  },
  {
    name: 'Mixed',
    href: '/all-auctions?condition=%5B"Mixed"%5D',
  },
  {
    name: 'Refurbished',
    href: '/all-auctions?condition=%5B"Refurbished"%5D',
  },
  {
    name: 'Salvage',
    href: '/all-auctions?condition=%5B"Salvage"%5D',
  },
  {
    name: 'Scratch & Dent',
    href: '/all-auctions?condition=%5B"Scratch%20%26%20Dent"%5D',
  },
  {
    name: 'Used',
    href: '/all-auctions?condition=%5B"Used"%5D',
  },
  {
    name: 'Used Fair',
    href: '/all-auctions?condition=%5B"Used%20Fair"%5D',
  },
  {
    name: 'Used Good',
    href: '/all-auctions?condition=%5B"Used%20Good"%5D',
  },
  {
    name: 'Device Grade A',
    href: '/all-auctions?condition=%5B"Device%20Grade%20A"%5D',
  },
  {
    name: 'Device Grade B',
    href: '/all-auctions?condition=%5B"Device%20Grade%20B"%5D',
  },
  {
    name: 'Device Grade C',
    href: '/all-auctions?condition=%5B"Device%20Grade%20C"%5D',
  },
  {
    name: 'Device Grade D',
    href: '/all-auctions?condition=%5B"Device%20Grade%20D"%5D',
  },
  {
    name: 'Device Grade E',
    href: '/all-auctions?condition=%5B"Device%20Grade%20E"%5D',
  },
]

export { conditionsData }
